import { Component, OnInit } from '@angular/core';

import { ChapterService } from '../../../services/chapter.service';
import { Chapter } from '../../../models/chapter';
import { ApplicationStateService } from '../../../services/application-state.service';
import { SingleChapterContentComponent } from './single-chapter-content/single-chapter-content.component';
import { PageFavoritesContentComponent } from './page-favorites-content/page-favorites-content.component';

@Component({
    selector: 'sidebar-chapter-content',
    templateUrl: './chapter-content.component.html',
    styleUrls: ['./chapter-content.component.scss'],
    standalone: true,
    imports: [
        SingleChapterContentComponent,
        PageFavoritesContentComponent
    ]
})
export class ChapterContentComponent implements OnInit {

    chapters: Array<Chapter>;

    constructor(public applicationStateService: ApplicationStateService,
                private chapterService: ChapterService) {
    }

    ngOnInit(): void {
        this.chapterService.getChapters().then(result => {
            this.chapters = result;
        });
    }

}
